import { Modal, Badge, Card } from "antd";
import "../../../style.css";

const ModalObservacao = ({
  isMostrarObservacao,
  handleCancel,
  observacoesAtuais,
}) => {
  return (
    <Modal
      title="Lista de observações"
      open={isMostrarObservacao}
      onCancel={handleCancel}
      cancelText="Fechar"
      okButtonProps={{ style: { display: "none" } }}
    >
      <div className="scroll-Y">
        {/* Observações formatadas */}
        {observacoesAtuais.formatadas.map((obs, index) => (
          <Badge.Ribbon
          style={{background: "#005a9e", fontWeight: 500}}
            key={index}
            text={obs.titulo.split(" - ")[0]} // Ex: "Observação 01"
          >
            <Card
              title={obs.titulo.split(" - ")[1]} // Ex: "09/09/2025"
              size="small"
              style={{ marginBottom: 16 }}
            >
              <div className="margin-btn observacao">
                <span>{obs.descricao}</span>
              </div>
            </Card>
          </Badge.Ribbon>
        ))}

        {/* Observações fora do padrão */}
        {observacoesAtuais.naoFormatadas.length > 0 && (
          <div className="outras-obs" style={{ marginTop: 16 }}>
            <strong style={{ color: "#856404" }}>
              Observação não formatada:
            </strong>
            {observacoesAtuais.naoFormatadas.map((linha, idx) => (
              <div
                key={idx}
                style={{ marginTop: "6px", color: "#856404" }}
              >
                {linha}
              </div>
            ))}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ModalObservacao;
